/** Is the user agent Apple OS? */
// eslint-disable-next-line @typescript-eslint/no-deprecated
export const IS_APPLE_OS = window.navigator.platform.toUpperCase().includes("MAC");
